import * as React from "react";
import './Account.css';
import { Grid, Tab, Tabs } from "@mui/material";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SecurityIcon from '@mui/icons-material/Security';
import { AccountDetailsTabForm } from "./AccountDetails";
import { SecurityDetails } from "./SecurityDetails";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number | string;
}

export function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export function tabPropsFunc(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
export const AccountPage: React.FC = () => {
    const [tabValue, setTabValue] = React.useState<number>(0);

    const handleTabValueChanged = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    }


    return (
        <div className="center">
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={tabValue} onChange={handleTabValueChanged} aria-label="TabswithIcons" centered>
                        <Tab icon={<AccountBoxIcon />} label="Account Details" {...tabPropsFunc(0)}/>
                        <Tab icon={<SecurityIcon />} label="Security" {...tabPropsFunc(1)}/>
                    </Tabs>
                    <TabPanel value={tabValue} index={0}>
                        <AccountDetailsTabForm />
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        <SecurityDetails />
                    </TabPanel>
                </Grid>
            </Grid>
        </div>
    );
}
